'use client';

import type { ComponentProps } from 'react';
import type { Modal } from '@zillow/constellation-10';
import { useMediaQuery } from '@zg-rentals/react-hooks';

type ModalDismissProps = ComponentProps<typeof Modal.Root>['useDismissProps'];

export const COARSE_POINTER = '(pointer: coarse)';

const TOUCH_DISMISS_PROPS: ModalDismissProps = { outsidePress: false };

// Android gesture nav starts its swipe on the backdrop; `undefined` elsewhere keeps Constellation's outsidePress filter.
export function useModalDismissProps(): ModalDismissProps {
  return useMediaQuery(COARSE_POINTER, true) ? TOUCH_DISMISS_PROPS : undefined;
}
